export const placementNamesBestPractices: TableBestPractices[] = [
  {
    device: 'site',
    context: 'home',
    position: 'middle',
    adType: 'banner',
    name: 'site_home_middle_banner'
  },
  {
    device: 'msite',
    context: 'product',
    position: 'top',
    adType: 'product',
    name: 'msite_product_top_product'
  },
  {
    device: 'app',
    context: 'search',
    position: 'top',
    adType: 'product',
    name: 'app_search_top_product'
  },
  {
    device: 'app',
    context: 'search',
    position: 'top',
    adType: 'banner',
    name: 'app_search_top_banner'
  },
  {
    device: 'site',
    context: 'category',
    position: 'bottom',
    adType: 'banner',
    name: 'site_category_bottom_banner'
  },
  {
    device: 'site',
    context: 'product',
    position: 'filter',
    adType: 'product',
    name: 'site_product_filter_product'
  }
]
